import {
  IConfig,
  useFlag,
  useUnleashContext
} from '@unleash/proxy-client-react';
import { useEffect, useMemo } from 'react';
import { config } from '../../config';
import { getIdTokenParsed } from './auth';

export type FeatureToggles = { [key in keyof typeof FEATURE_TOGGLE]: boolean };

export const FEATURE_TOGGLE = {
  FAQ: 'claim-web_faq_feature_toggle',
  MAINTENANCE: 'claim-web_maintenance',
  VALIDATE_COLLECTIVE_POLICY: `claim-web_validate-collective-policy`,
  VALIDATE_CORPORATE_POLICY: 'claim-web_validate-corporate-policy',
  VALIDATE_PRIVATE_POLICY: 'claim-web_validate-private-policy',
  USE_REBRANDED_ASSETS: 'claim-web_use-rebranded-assets'
} as const;

export const useFeatureToggles = (): FeatureToggles => {
  const updateContext = useUnleashContext();
  const faqFeatureToggle = useFlag(FEATURE_TOGGLE.FAQ);
  const maintenanceFeatureToggle = useFlag(FEATURE_TOGGLE.MAINTENANCE);
  const validateCollectivePolicyFeatureToggle = useFlag(
    FEATURE_TOGGLE.VALIDATE_COLLECTIVE_POLICY
  );
  const validateCorporatePolicyFeatureToggle = useFlag(
    FEATURE_TOGGLE.VALIDATE_CORPORATE_POLICY
  );
  const validatePrivatePolicyToggle = useFlag(
    FEATURE_TOGGLE.VALIDATE_PRIVATE_POLICY
  );
  const useRebrandedAssets = useFlag(FEATURE_TOGGLE.USE_REBRANDED_ASSETS);
  const cmId = getIdTokenParsed()?.cm_id;

  useEffect(() => {
    if (cmId) {
      updateContext({
        properties: {
          cmId
        }
      });
    }
  }, [updateContext, cmId]);

  return useMemo(
    () => ({
      FAQ: faqFeatureToggle,
      MAINTENANCE: maintenanceFeatureToggle,
      VALIDATE_COLLECTIVE_POLICY: validateCollectivePolicyFeatureToggle,
      VALIDATE_CORPORATE_POLICY: validateCorporatePolicyFeatureToggle,
      VALIDATE_PRIVATE_POLICY: validatePrivatePolicyToggle,
      USE_REBRANDED_ASSETS: useRebrandedAssets
    }),
    [
      faqFeatureToggle,
      maintenanceFeatureToggle,
      validateCollectivePolicyFeatureToggle,
      validateCorporatePolicyFeatureToggle,
      validatePrivatePolicyToggle,
      useRebrandedAssets
    ]
  );
};

export const unleashConfig: IConfig = {
  url: window.env.UNLEASH_PROXY_URL,
  clientKey: config.name,
  refreshInterval: window.env.UNLEASH_REFRESH_INTERVAL,
  appName: config.name,
  environment: window.env.ENVIRONMENT
};
